<template>
  <v-col lg="2" md="2" sm="6" xs="12">
    <v-card class="bordered-card" outlined tile v-on="$listeners"> 
      <v-list class="pa-0">
        <v-list-item>
          <v-list-item-content class="pa-0">
            <small>{{$attrs.datax.name}}</small>
          </v-list-item-content>
          <v-spacer></v-spacer>
          <v-list-item-icon class="ma-0 pa-0 align-self-center">
            <v-icon>mdi-chevron-right</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-card>
  </v-col>
</template>
<script>
 

export default {
  name: "TextCard",
  props: {
    title: {
      type: String,
      required: false,
    },
    bgColor: {
      type: String,
      required: false,
    },
  },
  data: () => ({
    //
  }),

  methods: {
    _getName(k) {
      return "Khangal-" + k;
    },
    _getBgColor() {
      if (this.bgColor != undefined && this.bgColor != null) {
        return this.bgColor;
      } else return "#bbb";
    },
  },
  
};

</script>
<style scoped>

.bordered-card:hover{
  border: 2px solid #bbb;
  cursor: pointer;
}
.bordered-card{
  display: flex;
  /* font-size: 1.6em; */
  min-height: 4em;

  background: #fff;
  border: 2px solid #f0f0f0;
  border-radius: 1px;
  box-sizing: border-box;
  color: #464646;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  line-height: 1.1;
  margin: 0 1% 12px;
  -webkit-box-ordinal-group: 1000;
  -webkit-order: 999;
  order: 999;
  
  position: relative;
  text-transform: capitalize;
}
</style>